import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;

const api = {
  Page:apiFuns.genStandard("page", "/api/datacenter"),
  SiteMap: apiFuns.genStandard("siteMap", "/api/datacenter")
};

export default api;
